import React from 'react'
import get from 'lodash/get'

const BANNER_SELECTORS = {
  layout: '.onetrust-pc-dark-filter',
  closeBannerButton: '#close-pc-btn-handler',
}

const CookieBannerLink = ({id, trackClick, children}) => {
  const closeBannerLayout = () => {
    const bannerLayout = document.querySelector(BANNER_SELECTORS.layout)
    if (bannerLayout) {
      bannerLayout.style = 'display: none;'
    }
  }

  const addCloseBannerSubscription = () => {
    const closeBannerButton = document.querySelector(BANNER_SELECTORS.closeBannerButton)
    if (closeBannerButton) {
      closeBannerButton.addEventListener('click', closeBannerLayout, {once: true})
    }
  }

  const showCookieBanner = () => {
    if (!get(window, 'OneTrust.ToggleInfoDisplay')) {
      // eslint-disable-next-line no-console
      console.info('OneTrust is not enabled for current env')
      return
    }

    window.OneTrust.ToggleInfoDisplay()

    // Add this workaround as click on close icon won't close banner layout
    addCloseBannerSubscription()
  }

  const onClick = ev => {
    ev.preventDefault()
    trackClick()
    showCookieBanner()
  }

  return (
    <a id={id} href="#" onClick={onClick}>
      {children}
    </a>
  )
}

export default CookieBannerLink
